import {Component, OnDestroy, OnInit} from '@angular/core';
import {DesignPreferenceService} from '../../../shared/services/design-preference.service';

@Component({
  selector: 'app-logged-layout',
  templateUrl: './logged-layout.component.html',
  styleUrls: ['./logged-layout.component.scss']
})
export class LoggedLayoutComponent implements OnInit, OnDestroy {

  newDesign: boolean;

  constructor(designPreference: DesignPreferenceService) {
    this.newDesign = designPreference.isNewDesign();
  }

  ngOnInit() {
    document.body.classList.toggle('new-design', this.newDesign);
  }

  ngOnDestroy() {
    document.body.classList.remove('new-design');
  }

}
